import { render } from "./Books.vue?vue&type=template&id=dbe3a9ac&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"

import "./Books.vue?vue&type=style&index=0&id=dbe3a9ac&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe3a9ac"]])

export default __exports__